var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTransactionPen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1640",
    "data-name": "Rectangle 1640",
    width: 33,
    height: 33,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(-2685 -914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(2694.625 922.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1630",
    "data-name": "Rectangle 1630",
    width: 11,
    height: 11,
    transform: "translate(0.375 12.75)",
    fill: "#43756a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1631",
    "data-name": "Rectangle 1631",
    width: 4,
    height: 5,
    rx: 2,
    transform: "translate(12.375 3.75)",
    fill: "#033933"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1632",
    "data-name": "Rectangle 1632",
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "translate(5.375 -0.25)",
    fill: "#608583"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_37",
    "data-name": "Mask Group 37",
    transform: "translate(2685 914)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "writing-tool",
    d: "M128.441.058c-.559-.232-1.206.21-2.309,1.574-.7.872-1.586,2.122-2.621,3.717-1.754,2.7-3.369,5.506-3.385,5.534a.479.479,0,0,0-.009.461l1.749,3.333-.9,2.177h-2.54a1.5,1.5,0,0,0-.479,2.921v.111a.543.543,0,0,1-.543.543h-.75a2.521,2.521,0,0,0-2.5,2.834l.667,5.338a.478.478,0,0,0,.031.956h11.234a.478.478,0,0,0,.031-.956l.667-5.338a2.521,2.521,0,0,0-2.5-2.834h-.75a.543.543,0,0,1-.543-.543v-.111a1.5,1.5,0,0,0-.479-2.921H122l1.1-2.651,2.553-1.163a.479.479,0,0,0,.247-.26c.011-.029,1.14-2.9,2.047-5.823a31.561,31.561,0,0,0,1.058-4.2C129.176,1.682,129.265.4,128.441.058Zm-4.909,21.328h.75a1.564,1.564,0,0,1,1.552,1.758l-.682,5.455h-9.368l-.682-5.455a1.564,1.564,0,0,1,1.552-1.758h.75a1.5,1.5,0,0,0,1.5-1.5v-.032h3.128v.032A1.5,1.5,0,0,0,123.532,21.386Zm-.479-3.032a.543.543,0,0,1-.543.543h-4.085a.543.543,0,0,1,0-1.085h4.085A.543.543,0,0,1,123.053,18.354Zm3.894-11.407c-.748,2.373-1.619,4.658-1.868,5.3l-1.442.657,3.109-7.5a.479.479,0,0,0-.885-.366l-3.517,8.491-1.256-2.392c.4-.684,1.645-2.805,3.013-4.933,2.71-4.214,3.694-5.043,3.99-5.205C128.193,1.248,128.385,2.39,126.948,6.947Z",
    transform: "translate(-105.133 1.73)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransactionPen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/transaction-pen.1df303c6.svg";
export { ForwardRef as ReactComponent };